import type { FunctionalComponent } from 'preact';
import { TERMS, type ConsentKind, type TermsDocument } from '@/data/terms.ts';

interface Props {
  /** null 이면 닫힌 상태 */
  kind: ConsentKind | null;
  onClose: () => void;
}

/** 본문의 `\n` 을 줄바꿈으로 그린다 */
const Lines: FunctionalComponent<{ text: string }> = ({ text }) => (
  <>
    {text.split('\n').map((line, i) => (
      <>
        {i > 0 && <br />}
        {line}
      </>
    ))}
  </>
);

/** 약관 한 건 (시안 `_info3.html` 의 표 구조) */
const TermsBody: FunctionalComponent<{ doc: TermsDocument }> = ({ doc }) => (
  <>
    <h1>{doc.title}</h1>
    <dl>
      <dd>
        <table>
          <colgroup>
            {doc.table.columns.map((width, i) => (
              <col key={i} style={{ width }} />
            ))}
          </colgroup>
          {doc.table.heading && (
            <thead>
              <tr>
                <th colSpan={doc.table.columns.length}>{doc.table.heading}</th>
              </tr>
            </thead>
          )}
          <tbody>
            {doc.table.rows.map((row, r) => (
              <tr key={r}>
                {row.map((cell, c) => (
                  <td key={c} class={cell.type ? 'type' : undefined}>
                    <Lines text={cell.text} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </dd>
    </dl>
    <p>{doc.notice}</p>
  </>
);

/** 약관 보기 팝업. kind 에 따라 본문만 바뀐다. */
export const ConsentTermsPopup: FunctionalComponent<Props> = ({ kind, onClose }) => (
  <div
    class={kind ? 'common-popup-overlay is-open' : 'common-popup-overlay'}
    onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}
  >
    <div class="common-popup">
      <div class="popup-header">
        <button type="button" class="popup-close" aria-label="닫기" onClick={onClose}>
          <img src="/images/close.png" alt="" />
        </button>
      </div>
      <div class="popup-body">
        <div class="popup-detail is-open">{kind && <TermsBody doc={TERMS[kind]} />}</div>
      </div>
    </div>
  </div>
);
